<template lang="pug">
.finance-audit-Quotation(v-loading="loading")
  title-bar {{ $t('项目信息') }}
  .info-display(v-if="quotationData")
    campaign-info-display(
      :campaignInfo="campaignInfo"
      :star="quotationData"
      :showStarDetailBtn="true"
    )
  .section-divider
  title-bar {{ $t('原始报价') }}
  unistar-tables(
    v-if="quotationData"
    :starData="quotationData"
  )
  .section-divider
  title-bar {{ $t('审核') }}
  div(v-if="isEdit")
    template(v-if="currentTask && currentTask.can_view")
      marketing-audit(:auditData="auditData" ref="audit")
      el-row.row-content(:gutter="20")
        el-col(:offset="4" :span="10")
          footer-button(
            @confirm="submit"
            @cancel="$router.push('/unistar/campaign-overview')"
          )
    template(v-else)
      .no-data {{ $t('待确认') }}
  .info-display(v-else)
    el-row.row-content(:gutter="20")
      el-col(:span="24")
        .info_label {{ $t('审核结果') }}
        .info_content {{ auditData.result === 1 ? $t('通过') : $t('拒绝') }}
    el-row.row-content(:gutter="20")
      el-col(:span="24")
        .info_label {{ $t('备注') }}
        .info_content {{ auditData.remark ? auditData.remark : '—' }}

</template>

<script>
import UnistarTables from '@/components/UnistarTables'
import MarketingAudit from '@/components/MarketingAudit'
import FooterButton from '@/components/FooterButton'
import UploadedFileDisplay from '@/components/UploadedFileDisplay'
import TitleBar from '@/components/TitleBar'
import CampaignInfoDisplay from '../components/CampaignInfoDisplay'
import axios from 'axios'

export default {
  components: {
    FooterButton,
    MarketingAudit,
    UnistarTables,
    UploadedFileDisplay,
    TitleBar,
    CampaignInfoDisplay
  },
  data () {
    return {
      loading: false,
      quotationData: null,
      auditData: {
        result: null,
        remark: ''
      },
      isEdit: false
    }
  },
  mounted () {
    this.getConfirmedStarPrice()
    this.getApproveResult(true)
  },
  computed: {
    campaignInfo () {
      return this.$store.state.unistar.campaignInfo
    },
    currentTask () {
      return this.$store.state.unistar.sowProcess.find(task => this.$route.path.includes(task.action))
    },
    sowInfo () {
      return this.$store.state.unistar.sowInfo
    }
  },
  methods: {
    getApproveResult (checkStatus) {
      axios.get('/management/subfinal/getApproveResult', {
        params: {
          id: this.campaignInfo.campaign_id,
          business_type: this.sowInfo.business_type,
          audit_type: 40
        }
      }).then(res => {
        this.loading = false
        if (checkStatus) {
          if (typeof res.status === 'number' && this.currentTask.status !== '进行中') {
            this.isEdit = false
            if (res.status) {
              this.auditData.result = res.status
            } else {
              this.auditData.result = 2
            }
            this.auditData.remark = res.comment
          } else {
            this.isEdit = true
          }
        } else {
          if (typeof res.status === 'number') {
            this.isEdit = false
            if (res.status) {
              this.auditData.result = res.status
            } else {
              this.auditData.result = 2
            }
            this.auditData.remark = res.comment
          } else {
            this.isEdit = true
          }
        }
      })
    },
    getConfirmedStarPrice () {
      this.loading = true
      axios.get('/management/star/getConfirmedStarPrice', {
        params: {
          campaign_id: this.campaignInfo.campaign_id,
          process_type: 3
        }
      })
        .then(res => {
          this.loading = false
          this.quotationData = res
        })
    },
    async submit () {
      if (!this.auditData.result) {
        this.$message.error(this.$t('请勾选审核结果'))
        return
      }
      if (this.auditData.result === 2 && !this.auditData.remark) {
        this.$message.error(this.$t('请填写备注'))
        return
      }
      const validateResult = await this.$refs.audit.$validator.validate()
      if (!validateResult) return
      this.loading = true
      axios.get('/management/star/approveForFinance', {
        params: {
          task_id: this.currentTask.taskId,
          campaign_id: this.campaignInfo.campaign_id,
          approve_result: this.auditData.result,
          remark: this.auditData.remark
        }
      })
        .then(res => {
          this.$store.dispatch('unistar/getCampaignInfo')
          this.$store.dispatch('unistar/getProcessTasks', {
            business_key: this.campaignInfo.campaign_id,
            business_type: this.sowInfo.business_type,
            phase_type: 1
          })
          this.getApproveResult()
          this.loading = false
          this.$message.success(this.$t('提交成功'))
          if (this.auditData.result === 2) {
            this.$router.push('/unistar/flow/campaign-info')
          }
        })
        .catch(err => {
          this.loading = false
          throw new Error(err)
        })
    }
  }
}
</script>

<style lang="stylus">
.finance-audit-Quotation .no-data
  height 300px
  display flex
  justify-content center
  align-items center
  font-size 30px
  color #e0e0e0
.footer-button
  padding-left 0

.procurement-enquiry-and-approve
  .category
    padding 0
  .uploaded-file-display
    > span
        width auto !important

.procurement-enquiry-and-approve__dialog
  .el-dialog
    width 800px
    .el-dialog__body
      > p
        text-align center

.procurement-enquiry-and-approve__autocomplete
  width 400px !important
.input-error
  padding 0 10px
</style>
